import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import { TCategoryListProps } from './definitions';
import MenuRow from '../../Molecules/MenuRow';
import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';

export default function CategoryList({ dataAuth }: TCategoryListProps) {
  const { setMenuDetailCategory, toggleMenuDetail } =
    React.useContext(SidebarMenuContext);

  const onClickSneakers = () => {
    toggleMenuDetail(true);
    setMenuDetailCategory('sneakers');
  };

  const onClickFashion = () => {
    toggleMenuDetail(true);
    setMenuDetailCategory('apparels');
  };

  const onClickLuxury = () => {
    toggleMenuDetail(true);
    setMenuDetailCategory('handbags');
  };

  const onClickElectronics = () => {
    toggleMenuDetail(true);
    setMenuDetailCategory('lifestyles');
  };

  return (
    <div>
      <MenuRow type="logo" withMarginHorizontal />
      <MenuRow
        type="item"
        withMarginHorizontal
        text="SNEAKERS"
        onClick={onClickSneakers}
      />
      <MenuRow
        type="item"
        withMarginHorizontal
        text="APPAREL"
        onClick={onClickFashion}
      />
      <MenuRow
        type="item"
        withMarginHorizontal
        text="LUXURY"
        onClick={onClickLuxury}
      />
      <MenuRow
        type="item"
        withMarginHorizontal
        text="ELECTRONICS & COLLECTIBLES"
        onClick={onClickElectronics}
      />
    </div>
  );
}
